import React, { useRef, useState } from "react";
import Slider from "react-slick";
import partner1 from './../assets/partner1.png'
import partner2 from './../assets/partner2.png'


const Customer = (props) => {
    const sliderRef = useRef(null);
    const [btnBgColor, setBtnBgColor] = useState(true)
    // const [totalLogoApear, setTotalLogoApear]=useState(4)
    // const [width,setWidth]=useState(windowWidth)
    const {windowWidth}=props
    
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: windowWidth>991 ? 5 : 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000 // Set the time (in milliseconds) between each slide transition
    };

    const partners = [
        { name: "Partner 1", logo: partner1 },
        { name: "Partner 2", logo: partner2 },
        { name: "Partner 3", logo: partner1 },
        { name: "Partner 4", logo: partner2 },
        { name: "Partner 5", logo: partner1 },
        { name: "Partner 4", logo: partner2 },

    ];

    const handleNext = () => {
        sliderRef.current.slickNext();
        setBtnBgColor(true)
    };

    const handlePrevious = () => {
        sliderRef.current.slickPrev();
        setBtnBgColor(false)
    };

  

    return (
        <div className="partner-container  pt-5 pb-5">

            <div className="container">
                <div className="header-partner-container d-flex-velo pb-5">

                    <h2 className="title-typo">Current Customer</h2>
                    <div>
                        <button className={"ml-velo rounded-btn same-btn-design" + (!btnBgColor ? ' btn-bg-velo' : ' btn-outline-velo')} onClick={handlePrevious}>
                            <i class="fa-solid fa-arrow-left"></i>
                        </button>

                        <button className={" rounded-btn same-btn-design" + (btnBgColor ? ' btn-bg-velo' : ' btn-outline-velo')} onClick={handleNext}>

                            <i class="fa-solid fa-arrow-right "></i>
                        </button>

                    </div>
                </div>
                <Slider {...settings} ref={sliderRef} className="slider-container-customer  " >
                    {partners.map((partner) => (
                        <div key={partner.name} className="customer-logo h-100 ">
                            <img src={partner.logo} alt={partner.name} className="" />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Customer;
